import { logAppError } from 'Helpers/logger'
import { templatePreviewState, templatesState } from '../state/templates'
import { campaignState } from '../state/campaign'
import {
  modalEmptySourceState,
  modalLimitDataContentState
} from '../state/modals'
import {
  getEmailTemplatePreview,
  getSourceContent,
  getTemplates
} from '../actions/carouselActions'
import {
  CATEGORY_TEMPLATES_NO_IMG,
  CATEGORY_TEMPLATES_WITH_IMG
} from 'Components/Carousel/CarouselUtils'
import { carouselState } from 'Components/Carousel/recoil/carousel'

export const initTemplateCarouselCallback =
  ({ set, snapshot }) =>
  async (withImage) => {
    set(templatesState, (prev) => ({
      ...prev,
      loading: true
    }))
    const {
      EmailOptions: { IdTemplate, TemplateType }
    } = await snapshot.getPromise(campaignState)
    try {
      let result

      if (
        TemplateType === CATEGORY_TEMPLATES_WITH_IMG ||
        TemplateType === CATEGORY_TEMPLATES_NO_IMG
      ) {
        set(carouselState, (prev) => ({
          ...prev,
          withImage: TemplateType === CATEGORY_TEMPLATES_WITH_IMG
        }))
        result = await getTemplates(withImage ? 1 : 0)

        set(campaignState, (prev) => ({
          ...prev,
          EmailOptions: {
            ...prev.EmailOptions,
            TemplateType: withImage ? 1 : 0
          }
        }))

        const selectedSlide = result.findIndex(
          (elem) => elem.idTemplate === IdTemplate
        )
        set(carouselState, (prev) => ({ ...prev, selectedSlide }))
      } else {
        result = await getTemplates(withImage)
      }
      set(templatesState, (prev) => ({ ...prev, templates: result }))
    } catch (error) {
      set(templatesState, (prev) => ({
        ...prev,
        error: true
      }))
      logAppError({
        appError: error,
        Component: 'Carousel',
        Method: 'initTemplateCarouselCallback'
      })
    }
    set(templatesState, (prev) => ({
      ...prev,
      loaded: true,
      loading: false
    }))
  }

export const fetchTemplateStructureCallback =
  ({ set, snapshot }) =>
  async (template) => {
    set(templatesState, (prev) => ({ ...prev, loading: true }))

    try {
      const { idTemplate, category } = template
      const { templates } = await snapshot.getPromise(templatesState)
      const {
        EmailOptions: { IdContentEndpoint }
      } = await snapshot.getPromise(campaignState)

      const selectedSlide = templates.findIndex(
        (elem) => elem.idTemplate === template.idTemplate
      )
      set(carouselState, (prev) => ({ ...prev, selectedSlide }))
      set(campaignState, (prev) => ({
        ...prev,
        EmailOptions: {
          ...prev.EmailOptions,
          IdTemplate: idTemplate,
          TemplateType: category
        }
      }))
      const body = await getEmailTemplatePreview(idTemplate, IdContentEndpoint)
      set(templatePreviewState, (prev) => ({ ...prev, idTemplate, body }))
    } catch (error) {
      set(templatesState, (prev) => ({ ...prev, error: true }))
      logAppError({
        appError: error,
        Component: 'Carousel',
        Method: 'fetchTemplateStructureCallback'
      })
    }
    set(templatesState, (prev) => ({ ...prev, loaded: true, loading: false }))
  }

export const checkSourceContentCallback =
  ({ set, snapshot }) =>
  async () => {
    const { IdSource, ShowNumberOfContents } =
      await snapshot.getPromise(campaignState)
    try {
      const sourceContent = await getSourceContent(IdSource)
      if (sourceContent === 0) {
        set(modalEmptySourceState, (prev) => ({
          ...prev,
          show: true
        }))
      } else if (sourceContent < ShowNumberOfContents) {
        set(modalLimitDataContentState, (prev) => ({
          ...prev,
          show: true,
          replaceValue: sourceContent
        }))
      }
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'ModalEmptySource',
        Method: 'checkSourceContentCallback'
      })
    }
  }
